'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002416 from "./presto.-Presto$$anon$16.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00242 from "./presto.-Presto$$anon$2.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$1() {
  this.bbz = null;
  this.bbr = null;
  this.bbs = false;
  this.bbA = null;
  this.bbB = false;
  this.bbE = null;
  this.bbx = null;
  this.bby = false;
  this.bbt = null;
  this.bbu = false;
  this.bbv = null;
  this.bbw = false;
  this.bbC = false;
  this.bbD = false;
  this.bbz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bbE = "SingleAppToken";
}
export { $c_Lpresto_Presto$$anon$1 as $c_Lpresto_Presto$$anon$1 };
$p = $c_Lpresto_Presto$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$1;
/** @constructor */
function $h_Lpresto_Presto$$anon$1() {
}
export { $h_Lpresto_Presto$$anon$1 as $h_Lpresto_Presto$$anon$1 };
$h_Lpresto_Presto$$anon$1.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bbz;
});
$p.M = (function() {
  if ((!this.bbs)) {
    this.bbr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bbs = true;
  }
  return this.bbr;
});
$p.O = (function() {
  if ((!this.bbB)) {
    this.bbA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bbB = true;
  }
  return this.bbA;
});
$p.D = (function() {
  return this.bbE;
});
$p.t = (function() {
  if ((!this.bby)) {
    this.bbx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bby = true;
  }
  return this.bbx;
});
$p.N = (function() {
  if ((!this.bbu)) {
    this.bbt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().GU(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().GU())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dPresto$0024$0024anon$00242.$c_Lpresto_Presto$$anon$2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bbu = true;
  }
  return this.bbt;
});
$p.Q = (function() {
  if ((!this.bbw)) {
    this.bbv = new $j_presto$002e$002dPresto$0024$0024anon$002416.$c_Lpresto_Presto$$anon$16();
    this.bbw = true;
  }
  return this.bbv;
});
$p.v = (function() {
  if ((!this.bbD)) {
    this.bbC = false;
    this.bbD = true;
  }
  return this.bbC;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee99) => ((p) => \u03b4scrutinee99.adK(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_Presto$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$1, "presto.Presto$$anon$1", ({
  Nd: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$1 as $d_Lpresto_Presto$$anon$1 };
//# sourceMappingURL=presto.-Presto$$anon$1.js.map
